<template>
    <div>
        <DCard>
            <DRow>
                <DCol>
                    <DTable
                        :items="files"
                        :fields="fields"
                    >
                        <template #created_at="{item}">
                            <td>
                                {{ setDateFormat(item.created_at) }}
                            </td>
                        </template>
                        <template #actions="{item}">
                            <td>
                                <div style="display: flex; grid-gap: 10px;">
                                    <DButton
                                        icon="download"
                                        mini
                                        @click="item.nitro_file === true ? downloadFile(item.id) : downloadWeSellFile(item)"
                                    />
                                    <DButton
                                        v-if="(userPermissions.includes('order.view') || userPermissions.includes('order.accept') || userPermissions.includes('order.reject')) && item.nitro_file === true && actionPossible === true"
                                        icon="trash-can-outline"
                                        color="danger"
                                        :disabled="isInLoadingState"
                                        mini
                                        @click="deleteFile(item.id)"
                                    />
                                    <DButton
                                        v-if="(userPermissions.includes('order.view') || userPermissions.includes('order.accept') || userPermissions.includes('order.reject')) && item.nitro_file === true && actionPossible === true"
                                        icon="pencil"
                                        mini
                                        @click="editFile(item)"
                                    />
                                </div>
                            </td>
                        </template>
                    </DTable>
                </DCol>
            </DRow>
        </DCard>

        <DFabs>
            <DFab
                v-if="canUploadFile"
                icon="plus"
                :label="__('orders.check.attachments_tab.create')"
                @click="openUploadModal"
            />
        </DFabs>

        <PsaUploadFile
            v-if="showUploadModal && canUploadFile"
            :order="data"
            :file="selectedItem"
            :show-modal="showUploadModal"
            @close-modal="closeUploadModal"
        />

        <DModal
            v-if="showConfirmationModal && actionPossible === true"
            v-model:show="showConfirmationModal"
            :title="__('orders.check.attachments_tab.delete_confirmation.title')"
            :message="__('orders.check.attachments_tab.delete_confirmation.message')"
            is-confirm
            is-error
            @close="showConfirmationModal = false"
            @confirm="deleteCallBack"
        />
    </div>
</template>

<script>
import OrderBase from '~@/Pages/Orders/Psa/Checks/Base'
import App from '~@/App.vue'
import PsaUploadFile from '~@/Components/Orders/Psa/PsaUploadFile'

export default {
    name: 'Attachments',
    components: { PsaUploadFile },
    layout: [App, OrderBase],
    props: {
        data: {
            type: Object,
            default: () => { return {} }
        },
        files: {
            type: Array,
            default: () => { return [] }
        }
    },
    data () {
        return {
            fields: [
                { key: 'description', label: this.__('orders.check.attachments_tab.description') },
                { key: 'original_name', label: this.__('orders.check.attachments_tab.original_name') },
                { key: 'created_at', label: this.__('orders.check.attachments_tab.created_at') },
                { key: 'user_name', label: this.__('orders.check.attachments_tab.username') },
                { key: 'actions', label: '' }
            ],
            showUploadModal: false,
            showConfirmationModal: false,
            selectedItem: {},
            deleteCallBack: () => {}
        }
    },
    computed: {
        userPermissions () {
            return this.$page.props.auth.permissions
        },
        actionPossible () {
            return this.data.clientCustomerId !== null && (this.data.status === 'clarification_external' ||
                this.data.status === 'clarification_internal')
        },
        canUploadFile () {
            return (
                this.userPermissions.includes('order.view') ||
                this.userPermissions.includes('order.accept') ||
                this.userPermissions.includes('order.reject')
            ) && this.data.clientCustomerId !== null
        }
    },
    methods: {
        downloadFile (id) {
            const link = document.createElement('a')
            link.href = this.$route('customers.customers.customer-files.download', {
                customer: this.data.clientCustomerId,
                customerFile: id
            })
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },
        downloadWeSellFile (file) {
            window.open(file.url, '_blank')
        },
        deleteFile (id) {
            this.deleteCallBack = () => {
                this.$inertia.delete(
                    this.$route('orders.psa.delete-file', {
                        customer_file: id
                    }),
                    {
                        preserveScroll: true
                    }
                )
                this.showConfirmationModal = false
            }
            this.showConfirmationModal = true
        },
        closeModal () {
            this.showConfirmationModal = false
            this.deleteCallBack = () => {}
        },
        editFile (item) {
            this.selectedItem = item
            this.showUploadModal = true
        },
        openUploadModal () {
            this.showUploadModal = true
        },
        closeUploadModal () {
            this.selectedItem = {}
            this.showUploadModal = false
        }
    }
}
</script>

<style scoped>

</style>
